import { render, staticRenderFns } from "./FollowUpView.vue?vue&type=template&id=df020998&scoped=true"
import script from "./FollowUpView.vue?vue&type=script&lang=js"
export * from "./FollowUpView.vue?vue&type=script&lang=js"
import style0 from "./FollowUpView.vue?vue&type=style&index=0&id=df020998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df020998",
  null
  
)

export default component.exports